import clsx from "clsx";
import React from "react";

type GradientButtonVariant = "small-button" | "large-button";

interface GradientButtonVariantProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: GradientButtonVariant;
  grayBackground?: boolean;
}

export const GradientButton: React.FC<GradientButtonVariantProps> = ({
  variant = "small-button",
  grayBackground = false,
  className,
  ...props
}) => (
  <button
    className={clsx(
      className,
      `gradient--button ${variant}`,
      grayBackground && "disabled-background--button"
    )}
    {...props}
  >
    {props.children}
  </button>
);
